import { render, staticRenderFns } from "./WithstandLoad.vue?vue&type=template&id=5a540022&"
import script from "./WithstandLoad.vue?vue&type=script&lang=js&"
export * from "./WithstandLoad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports